module.exports = __webpack_public_path__ + "static/media/arrow_upward.dd3d545b.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/arrow_upward.svg
// module id = 1980
// module chunks = 0